import Utils from "./utils";
import YouTubePlayer from 'youtube-player';


class Video {

	/**
	 * @param options
	 */
	constructor() {

		Utils.debug('VIDEO :: construct');

		this.$videos = $('.video');

		if(this.$videos.length === 0){
			return;
		}

		this.$videos.each((index, elt) => {
			this.init($(elt));
		})

	}


	init($elt){
		//console.debug('VIDEOS :: init');

		// Gestion Youtupe
		if($elt.data('type') === 'youtube' && $elt.data('uid') !== ''){
			// on initialise le player en dessous de toutes les images
			$elt.player = YouTubePlayer('player' + $elt.data('uid'));
			$elt.uid = $elt.data('uid');

			// on check les changemetns d'état pour permettre de réafficher la miniature et le bouton play quand on pause le player
			$elt.player.on('stateChange', (event) => {
				if (event.data === YT.PlayerState.ENDED || event.data === YT.PlayerState.PAUSED) {
					this.showThumbnail($elt);
				}
			});

			// Gestion self hosted (mp4)
		} else {
			$elt.player = $elt.find('video').get(0);
			$elt.find('video').on('pause', () => {
				this.showThumbnail($elt);
			});
		}




		// click sur l'image + bouton play qui est par dessus la vidéo
		$elt.find('.video__image').on('click', (index, elt) => {
			this.clickOnPlay($elt);
		});

	}

	/**
	 * Handler qunad on click sur le bouton play
	 * @param $elt
	 */
	clickOnPlay($elt){

		if($elt.data('type') === 'youtube'){
			$elt.player.loadVideoById($elt.uid);
		} else {
			$elt.player.play();
		}
		this.hideThumbnail($elt);
	}


	/**
	 * Masque l'image et le bouton play du player
	 * @param $elt
	 */
	hideThumbnail($elt){
		gsap.to($elt.find('.video__image'), 0.6, {autoAlpha: 0});
		gsap.to($elt.find('.video__image__play'), 0.4, {yPercent: -50});
	}

	/**
	 * Affiche l'image et le bouton play du player
	 * @param $elt
	 */
	showThumbnail($elt){
		gsap.to($elt.find('.video__image'), 0.6, {autoAlpha: 1});
		gsap.to($elt.find('.video__image__play'), 0.4, {yPercent: -50});
	}


}

module.exports = Video;
